import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import sologo from '../assets/images/sologo.png';
import logoTrilha from '../assets/images/logo_trilha.png';
import Form from './preIncubacaoForm';
import PreIncubacaoIdeacao from '../preIncubacaoIdeacao/preIncubacaoIdeacao';
import PreIncubacaoPrototipo from '../preIncubacaoPrototipo/preIncubacaoPrototipo';
import PreIncubacaoValidacao from '../preIncubacaoValidacao/preIncubacaoValidacao';
import PreIncubacaoPitch from '../preIncubacaoPitch/preIncubacaoPitch';
import imagemFundo from '../assets/images/trilhaConhecimento/fundo.png';
import imagemFundoIdeacao from '../assets/images/trilhaConhecimento/ideacao/fundo.png';
import { setModoTela, initForm, salvar, getLista, getListaUsuario } from './trilhaConhecimentoActions';
import { initForm as initFormIdeacao, getLista as getListaIdeacao } from '../preIncubacaoIdeacao/preIncubacaoIdeacaoActions';
import { initForm as initFormPrototipo, getLista as getListaPrototipo } from '../preIncubacaoPrototipo/preIncubacaoPrototipoActions';
import { initForm as initFormValidacao, getLista as getListaValidacao } from '../preIncubacaoValidacao/preIncubacaoValidacaoActions';
import { initForm as initFormPitch, getLista as getListaPitch } from '../preIncubacaoPitch/preIncubacaoPitchActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';
import PreIncubacaoIdeacaoForm from '../preIncubacaoIdeacao/preIncubacaoIdeacaoForm';
import PreIncubacaoPrototipoForm from '../preIncubacaoPrototipo/preIncubacaoPrototipoForm';
import PreIncubacaoValidacaoForm from '../preIncubacaoValidacao/preIncubacaoValidacaoForm';
import PreIncubacaoPitchForm from '../preIncubacaoPitch/preIncubacaoPitchForm';

class AdmTrilhaConhecimento extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {
		this.props.getLista();
		this.props.getListaUsuario();
		this.props.getListaIdeacao();
		this.props.getListaPrototipo();
		this.props.getListaValidacao();
		this.props.getListaPitch();
		this.props.getListaTexto();
	}

    componentWillMount() {
    }

    render() {
		
		let fundo = imagemFundo;
		if (this.props.modoTela == 'ideacao') {
			fundo = imagemFundoIdeacao;
		}

        return (
            <Background
				backgroundPosition={'center'}
				gradientStart='#ffffff'
				gradientEnd='#ffffff'>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'trilha' ? this.trilha() : null}
					
					{this.props.modoTela == 'cadastro' ? <Form onSubmit={this.props.salvar} /> : null}

					{this.props.modoTela == 'ideacao' ? <PreIncubacaoIdeacaoForm modoAdm visualizacao /> : null}
					{this.props.modoTela == 'prototipo' ? <PreIncubacaoPrototipoForm modoAdm visualizacao /> : null}
					{this.props.modoTela == 'validacao' ? <PreIncubacaoValidacaoForm modoAdm visualizacao /> : null}
					{this.props.modoTela == 'pitch' ? <PreIncubacaoPitchForm modoAdm visualizacao /> : null}

                </Content>
            </Background>
        )
    }

	trilha() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome} ${DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)} 
					${item.nome_usuario} ${item.nome_projeto}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					
					<h3 style={{ color: '#0F2748', textAlign: 'center', fontWeight: 'bold', marginBottom: 16 }}>TRILHA DE CONHECIMENTO DE NEGÓCIO</h3>

					<Row alignCenter>
						<Grid cols='12 8 6 3' style={{ margin: 8 }}>
							<Button
								text='Criar Nova Trilha'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				
				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />
			
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Empreendedor</Th>
								<Th alignCenter>Nome do Projeto</Th>
								<Th alignCenter></Th>								
								<Th alignCenter>Ideação</Th>
								<Th alignCenter>Protótipo e Validação</Th>
								<Th alignCenter>Modelo de Negócio</Th>
								<Th alignCenter>Pitch</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {
								const registroIdeacao = this.props.listaIdeacao.filter(itemTrilha => itemTrilha.id_pre_incubacao == item.id)[0];
								const registroPrototipo = this.props.listaPrototipo.filter(itemTrilha => itemTrilha.id_pre_incubacao == item.id)[0];
								const registroValidacao = this.props.listaValidacao.filter(itemTrilha => itemTrilha.id_pre_incubacao == item.id)[0];
								const registroPitch = this.props.listaPitch.filter(itemTrilha => itemTrilha.id_pre_incubacao == item.id)[0];

								let status = 'Ideação';
								let buttonText = null;
								if (item.pitch) {
									status = 'Finalizada';
								} else if (registroPitch) {
									status = 'Pitch em Análise';
									buttonText = 'Finalizar Trilha';
								} else if (item.validacao) {
									status = 'Pitch';
								} else if (registroValidacao) {
									status = 'Validação em Análise';
									buttonText = 'Avançar para Pitch';
								} else if (item.prototipo) {
									status = 'Validação';
								} else if (registroPrototipo) {
									status = 'Protótipo em Análise';
									buttonText = 'Avançar para Validação';
								} else if (item.ideacao) {
									status = 'Protótipo';
								} else if (registroIdeacao) {
									status = 'Ideação em Análise';
									buttonText = 'Avançar para Protótipo';
								} else {
									status = 'Ideação';
								}

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
										<Td alignCenter>{item.nome_usuario}</Td>
										<Td alignCenter>{item.nome_projeto}</Td>
										<Td alignCenter minWidth={10}>
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												disabled={false}
												event={() => {
													this.props.setModoTela('cadastro', { ...item });
													this.props.initForm({ ...item });
												}} />
										</Td>
										<Td alignCenter minWidth={10}>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												disabled={!registroIdeacao}
												event={() => {
													this.props.initFormIdeacao({
														...registroIdeacao
													});
													this.props.setModoTela('ideacao');
												}} />
										</Td>
										<Td alignCenter minWidth={10}>																			
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												disabled={!registroPrototipo}
												event={() => {
													this.props.initFormPrototipo({
														...registroPrototipo
													});
													this.props.setModoTela('prototipo');
												}} />
										</Td>
										<Td alignCenter minWidth={10}>																			
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												disabled={!registroValidacao}
												event={() => {
													this.props.initFormValidacao({
														...registroValidacao
													});
													this.props.setModoTela('validacao');
												}} />
										</Td>
										<Td alignCenter minWidth={10}>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												disabled={!registroPitch}
												event={() => {
													this.props.initFormPitch({
														...registroPitch
													});
													this.props.setModoTela('pitch');
												}} />
										</Td>
										<Td alignCenter>{status}</Td>
										<Td alignCenter>
											{buttonText && 
											<Button
												text={buttonText}
												type={'primary'}
												icon={'fa fa-plus'}
												event={() => {

													if (window.confirm(`Tem certeza que deseja ${buttonText}?`)) {

														if (buttonText == 'Finalizar Trilha') {
															this.props.salvar({
																...item,
																pitch: true,
																data_final: DateFormat.getDataAtual()
															});
														} else if (buttonText == 'Avançar para Pitch') {
															this.props.salvar({
																...item,
																validacao: true
															});
														} else if (buttonText == 'Avançar para Validação') {
															this.props.salvar({
																...item,
																prototipo: true
															});
														} else if (buttonText == 'Avançar para Protótipo') {
															this.props.salvar({
																...item,
																ideacao: true
															});
														}
													}
												}} />}
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.trilhaConhecimento.modoTela,
	aguardando: state.trilhaConhecimento.aguardando,
	lista: state.trilhaConhecimento.lista,
	listaIdeacao: state.preIncubacaoIdeacao.lista,
	listaPrototipo: state.preIncubacaoPrototipo.lista,
	listaValidacao: state.preIncubacaoValidacao.lista,
	listaPitch: state.preIncubacaoPitch.lista,
	trilhaConhecimentoTitulo: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoTitulo').map(item => item.valor)[0],
	trilhaConhecimentoTituloNaoIniciada: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoTituloNaoIniciada').map(item => item.valor)[0],
	trilhaConhecimentoDescricaoNaoIniciada: state.texto.lista.filter(item => item.chave == 'trilhaConhecimentoDescricaoNaoIniciada').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, getLista, getListaUsuario,
	getListaIdeacao, getListaPrototipo, getListaValidacao, getListaPitch,
	getListaTexto,
	initFormIdeacao, initFormPrototipo, initFormValidacao, initFormPitch
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AdmTrilhaConhecimento);
